import { Engine } from 'json-rules-engine';
import { isNullOrUndefined } from '@bimser/core';

export function getRulesEngine(): Engine {
	const engineInstance = new Engine();

	engineInstance.addOperator('null', (a: any, b: any) => isNullOrUndefined(a) || a === '');

	engineInstance.addOperator('notNull', (a: any, b: any) => !isNullOrUndefined(a) && a !== '');

	engineInstance.addOperator('startsWith', (a: string, b: string) => a?.startsWith(b));

	engineInstance.addOperator('endsWith', (a: string, b: string) => a?.endsWith(b));

	engineInstance.addOperator('contains', (a: string, b: string) => a?.indexOf(b) > -1);

	engineInstance.addOperator(
		'doesNotContain',
		(a: string, b: string) => !a || a.indexOf(b) === -1
	);

	return engineInstance;
}
